module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_1.15d4c396.png";